import {
  OEButton,
  OEText,
  Skeleton,
  useModal,
} from '@openeducation/oe-it-components';
import { getTimeFromDate } from '@openeducation/oe-it-services';
import React from 'react';
import { DataTable } from 'react-native-paper';

import { ClassFeedbackEmpty } from './class-feedback-empty';
import { Card } from '../../atoms/card/card';
import { useLiveClass } from '../../hooks/use-live-class';
import type { OlderLiveClass } from '../../interfaces/older-live-class';
import { ClassFeedbackModal } from '../../molecules/class-feedback-modal/class-feedback-modal';

export interface ClassFeedbackCardProps {}

export const ClassFeedbackCard = () => {
  const { olderLiveClasses, isLoadingOlderLiveClasses } = useLiveClass();
  const { openModal } = useModal();

  const handlePress = (liveClass: OlderLiveClass) => {
    openModal(<ClassFeedbackModal liveClassId={liveClass.id} />);
  };

  return (
    <Card title="Class Feedback" fullWidth>
      {!isLoadingOlderLiveClasses && !olderLiveClasses?.length ? (
        <ClassFeedbackEmpty />
      ) : (
        <DataTable>
          <DataTable.Header>
            <DataTable.Title>
              <OEText fontType="bold" fontSize={14}>
                ID
              </OEText>
            </DataTable.Title>
            <DataTable.Title>
              <OEText fontType="bold" fontSize={14}>
                Date
              </OEText>
            </DataTable.Title>
            <DataTable.Title>
              <OEText fontType="bold" fontSize={14}>
                Title
              </OEText>
            </DataTable.Title>
            <DataTable.Title>
              <OEText fontType="bold" fontSize={14}>
                Status
              </OEText>
            </DataTable.Title>
            <DataTable.Title> </DataTable.Title>
          </DataTable.Header>

          {isLoadingOlderLiveClasses ? (
            <>
              {[1, 2].map((key) => (
                <DataTable.Row key={key}>
                  <DataTable.Cell>
                    <Skeleton />
                  </DataTable.Cell>
                </DataTable.Row>
              ))}
            </>
          ) : (
            <>
              {olderLiveClasses?.map((liveClass) => (
                <DataTable.Row key={liveClass.id}>
                  <DataTable.Cell>{liveClass.id}</DataTable.Cell>
                  <DataTable.Cell>
                    {getTimeFromDate(liveClass.classBegin, 'PPp')}
                  </DataTable.Cell>
                  <DataTable.Cell>{liveClass.title}</DataTable.Cell>
                  <DataTable.Cell>
                    {liveClass.studentIdsAndFeedback?.length ?? 0} /{' '}
                    {liveClass.studentIdsAndNames.length} complete
                  </DataTable.Cell>
                  <DataTable.Cell>
                    <OEButton
                      size="small"
                      onPress={() => handlePress(liveClass)}
                    >
                      Write feedback
                    </OEButton>
                  </DataTable.Cell>
                </DataTable.Row>
              ))}
            </>
          )}
        </DataTable>
      )}
    </Card>
  );
};
